export default {"src":"/_next/static/media/Vector3.2740e3ba.svg","height":50,"width":48,"blurWidth":0,"blurHeight":0};